import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function ChapterTag({ index, label }) {
  return (
    <div className="flex items-center gap-3" data-testid={`chapter-${index}`}>
      <span className="font-mono text-xs tracking-[0.3em] text-[#00F5A0]">{index}</span>
      <span className="h-px w-10 bg-[#00F5A0]/40" />
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">{label}</span>
    </div>
  );
}
